var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mb-6"},[_c('v-card-title',{staticClass:"themed-card-title mb-6"},[_vm._v(" Terms of Use ")]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.$store.state.websiteVariables.termsOfUse)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }